﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const OperationalContextClient_1 = require("./swagger/OperationalContextClient");
class UserClient {
    constructor() {
        this.client = new OperationalContextClient_1.OperationalContextClient();
    }
    get(username) {
        return this.client.apiUsersByIdGet(username);
    }
    getAll() {
        return this.client.apiUsersGet();
    }
    getAvailableUsersToBecomeDrivers() {
        return this.client.apiUsersAvailableuserstobecomedriversGet();
    }
    getEditable() {
        return this.client.apiUsersEditableGet();
    }
    create(user) {
        return this.client.apiUsersPost(user);
    }
    update(existingUser, user) {
        return this.client.apiUsersByIdPut(existingUser, user);
    }
    resetPassword(username, resetPasswordRequest) {
        return this.client.apiUsersPasswordResetByIdPut(username, resetPasswordRequest);
    }
    updatePassword(username, updatePasswordRequest) {
        return this.client.apiUsersPasswordUpdateByIdPut(username, updatePasswordRequest);
    }
    resetPin(username, updatePinRequest) {
        return this.client.apiUsersPinResetByIdPut(username, updatePinRequest);
    }
    delete(data) {
        return this.client.apiUsersDelete(data);
    }
}
exports.UserClient = UserClient;
//# sourceMappingURL=UserClient.js.map